// extracted by mini-css-extract-plugin
export default {"application-page":"ApplicationPage_application-page__v0HJx","application-title":"ApplicationPage_application-title__oh84Z"};